module.exports = __webpack_public_path__ + "static/bitnational_whitepaper.8fd3c4dd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bitnational_whitepaper.pdf
// module id = 590
// module chunks = 154199477766010